'use client';

import { isKbfProductType } from '@dealerportal/common';
import { KbfProductDetails } from './KbfProductDetails';
import { ProductDetails, type ProductDetailsProps } from './ProductDetails';

/**
 * Renders the product detail page that fits the product: the KB&F page
 * (3D viewer + configurator) for cabinetry, worktops and bath items, the
 * flooring page for everything else.
 */
export const ProductDetailsSwitch = (props: ProductDetailsProps) =>
  isKbfProductType(props.productInfo) ? (
    <KbfProductDetails {...props} />
  ) : (
    <ProductDetails {...props} />
  );
